import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\u20cs\\Desktop\\weekrtLanding\\weekrt-landing-page\\components\\content-1.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\u20cs\\Desktop\\weekrtLanding\\weekrt-landing-page\\components\\hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\u20cs\\Desktop\\weekrtLanding\\weekrt-landing-page\\components\\how-it-works.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\u20cs\\Desktop\\weekrtLanding\\weekrt-landing-page\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\u20cs\\Desktop\\weekrtLanding\\weekrt-landing-page\\node_modules\\next\\dist\\client\\image-component.js");
